angular.module('ihestiaWidgets.policyDetails')
  .directive('ihestiaLifeRiskTable', ['ihestiaSumInsuredVectorModalHelper',
    function(ihestiaSumInsuredVectorModalHelper) {
      return {
        templateUrl: 'ihestia-widgets-templates-app/policyDetails/life/riskTable/lifeRiskTable.tpl.html',
        restrict: 'E',
        scope: {
          riskTable: '=',
          hidePremium: '=',
          disabilityMonthlyBenefits: '='
        },
        link: function(scope) {
          scope.showSumInsuredVector = function(sumInsuredVector) {
            ihestiaSumInsuredVectorModalHelper.showModal({
              sumInsuredVector: sumInsuredVector
            }).then(lsnNg.noop, lsnNg.noop);
          };

          scope.showSumInsuredVectorWithMonthlyBenefit = function(sumInsuredVector, disabilityMonthlyBenefits) {
            ihestiaSumInsuredVectorModalHelper.showModal({
              sumInsuredVector: sumInsuredVector,
              disabilityMonthlyBenefits: {
                tnd: (disabilityMonthlyBenefits && disabilityMonthlyBenefits.tnd) ? disabilityMonthlyBenefits.tnd : null,
                tns: (disabilityMonthlyBenefits && disabilityMonthlyBenefits.tns) ? disabilityMonthlyBenefits.tns : null
              }
            }).then(lsnNg.noop, lsnNg.noop);
          };
        }
      };
    }]);
